import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";
import ImpactPaths from "@/sections/ImpactPaths";
import Approach from "@/sections/Approach";
import FinalCTA from "@/sections/FinalCTA";

export default function Services() {
  return (
    <>
      <Seo path="/services" title="مساراتنا في التأثير" description="سبعة مسارات نصنع بها الأثر: المشاركة المجتمعية، الابتكار الاجتماعي، الاستثمار الاجتماعي، منظومة ضيوف الرحمن، الريادة الاجتماعية، تنمية المجتمعات، المسؤولية الاجتماعية." />
      <PageHead eyebrow="مساراتنا في التأثير" title="مساراتنا في التأثير" subtitle="نصمّم حلولنا الاستشارية وفق سياق المنظمة، واحتياجاتها، والفرص الأكثر أولوية" />
      <Approach />
      <ImpactPaths id="paths" />
      <FinalCTA />
    </>
  );
}
